import { YextState, RootState } from '@/store/state_models'
import { Module, ActionContext } from 'vuex'

function getInitialData(): YextState {
  return {
    isEditListingFormEnabled: false,
  }
}

export const yext: Module<YextState, RootState> = {
  namespaced: true,
  state: getInitialData(),
  getters: {
    getIsEditListingFormEnabled: (state: YextState) => {
      return state?.isEditListingFormEnabled
    },
  },
  mutations: {
    setIsEditListingFormEnabled: (state: YextState, payload: boolean) => {
      state.isEditListingFormEnabled = payload
    },
  },
  actions: {
    setIsEditFormEnabled: {
      handler: async (
        context: ActionContext<YextState, RootState>,
        value: boolean
      ) => {
        context.commit('setIsEditListingFormEnabled', value)
      },
    },
  },
}
